import { useEffect, useState } from "react";

/** Dialog do wizard: o Figma ancora o toast dentro dele (400px, canto superior direito sob o header). */
const DIALOG_SELECTOR = '[data-testid="nova-obra-dialog"]';

export function useWizardToast() {
  const [host, setHost] = useState<HTMLElement | undefined>(undefined);

  useEffect(() => {
    setHost(document.querySelector<HTMLElement>(DIALOG_SELECTOR) ?? undefined);
  }, []);

  return { appendTo: host ?? document.body, ancorado: host !== undefined };
}
